export default __webpack_public_path__ + "static/media/zinggalas.330510c3.png";